import { ReactNode } from 'react'

import Box from '@mui/material/Box'

import { TLink } from 'components/@material-extend/MBreadcrumbs'
import HeaderBreadcrumbs from 'components/HeaderBreadcrumbs'
import Page from 'components/Page'

interface PageWrapperProps {
  title?: ReactNode | string | null
  children: ReactNode
  links: TLink[]
  titleHead?: string
  action?: ReactNode
  more?: ReactNode
  childrenRight?: ReactNode
  scrollable?: boolean
}

const PageWrapper = ({
  children,
  titleHead = 'DoFarm',
  title,
  links,
  action,
  more,
  childrenRight,
  scrollable = true,
}: PageWrapperProps) => {
  const overflowStyles = scrollable ? { overflow: 'auto' } : { overflow: 'hidden' }
  return (
    <Page title={titleHead}>
      <Box
        sx={{
          minHeight: '100dvh',
          display: 'flex',
          flexDirection: 'column',
          px: { xs: 1, sm: 5 },
          overflow: 'hidden',
        }}
      >
        <Box sx={{ mb: 3 }}>
          <HeaderBreadcrumbs heading={title} links={links} action={action} />
          {more}
        </Box>
        {children}
      </Box>
    </Page>
  )
}

export default PageWrapper
